"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentLoopRegistryWidget = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var Types_1 = require("Tokens/Types");
var WidgetManager_1 = require("../../WidgetManager");
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var WidgetTokenDropArea_1 = require("../WidgetTokenDropArea/WidgetTokenDropArea");
var Types_2 = require("@CommonFrontendBackend/Tokens/Types");
var VariableActions_1 = require("Project/QwilrEditor/Behaviours/VariableActions");
var TokenSearchContext_1 = __importDefault(require("Project/QwilrEditor/Providers/TokenScope/TokenSearchContext"));
var inversify_react_1 = require("inversify-react");
var ContentLoopWidgetContext_1 = require("./ContentLoopWidgetContext");
var ContentLoopWidget = (function (_super) {
    __extends(ContentLoopWidget, _super);
    function ContentLoopWidget() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.handleDropAreaClick = function (event) {
            event.preventDefault();
            if (!_this.context) {
                throw new Error("Cannot handleDropAreaClick outside of ContentLoopContext");
            }
            _this.context.setMode("editToken");
        };
        _this.handleTokenDrop = function (event) {
            event.preventDefault();
            event.stopPropagation();
            var variable = (0, VariableActions_1.getVariableTokenFromDragEvent)(event);
            if (!variable || (variable === null || variable === void 0 ? void 0 : variable.dataType) !== Types_2.TokenDataType.List) {
                return;
            }
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("contentLoop", {
                action: EditorTypes_1.ContentLoopActionType.DropContentLoopVariable,
                path: _this.props.widgetManager.getPath(_this.props.element),
                variable: variable,
            }));
        };
        _this.isSupportedDragType = function (event) {
            var variable = (0, VariableActions_1.getVariableTokenFromDragEvent)(event);
            return (variable === null || variable === void 0 ? void 0 : variable.dataType) === Types_2.TokenDataType.List;
        };
        return _this;
    }
    Object.defineProperty(ContentLoopWidget.prototype, "hasVariable", {
        get: function () {
            return !!this.props.variable;
        },
        enumerable: false,
        configurable: true
    });
    ContentLoopWidget.prototype.render = function () {
        var _a = this.props, children = _a.children, attributes = _a.attributes, enableTokens = _a.enableTokens;
        var instructions = enableTokens === Types_1.TokensEnableState.EnabledWithAllInteractions
            ? "Click or drag to select a repeating token. Content will repeat for each item in the token."
            : "Click to select a repeating token. Content will repeat for each item in the token.";
        return (react_1.default.createElement("div", __assign({ className: "content-loop-widget" }, attributes),
            react_1.default.createElement("div", { className: "content-loop-widget__inner-wrapper" },
                !this.hasVariable && (react_1.default.createElement(WidgetTokenDropArea_1.WidgetTokenDropArea, { borderless: true, size: WidgetTokenDropArea_1.WidgetTokenDropAreaSize.Medium, isSelected: false, onDrop: this.handleTokenDrop, onDropAreaClick: this.handleDropAreaClick, instructions: instructions, customDragDrop: {
                        isSupportedType: this.isSupportedDragType,
                        customDragMessage: "Release to add repeating token",
                    }, icon: icons_1.Loop })),
                react_1.default.createElement("div", { className: (0, classnames_1.default)("content-loop-widget__content", {
                        "content-loop-widget__content--visible": this.hasVariable,
                    }) },
                    react_1.default.createElement(TokenSearchContext_1.default.Provider, { value: this.props.variable }, children)))));
    };
    ContentLoopWidget.contextType = ContentLoopWidgetContext_1.ContentLoopWidgetContext;
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ContentLoopWidget.prototype, "hasVariable", null);
    ContentLoopWidget = __decorate([
        mobx_react_1.observer
    ], ContentLoopWidget);
    return ContentLoopWidget;
}(react_1.default.Component));
var ContentLoopRegistryWidget = function (_a) {
    var element = _a.element, children = _a.children;
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var tokensEnableState = (0, inversify_react_1.useInjection)("tokensEnableState");
    return (react_1.default.createElement(ContentLoopWidget, { widgetManager: widgetManager, element: element, attributes: {}, enableTokens: tokensEnableState, variable: element.data.variable }, children));
};
exports.ContentLoopRegistryWidget = ContentLoopRegistryWidget;
exports.default = ContentLoopWidget;
